import clickOutside from "./helpers/clickOutSide";

document.addEventListener("DOMContentLoaded", () => {
  const shareBtns = document.querySelectorAll(".share-socials__btn");
  const shareModals = document.querySelectorAll(".share-socials__modal");

  const toggleModal = (modal) => {
    if (!modal.classList.contains("shown")) {
      const modalWrapper = modal.querySelector(".share-socials__wrapper");
      modal.style.maxHeight = modalWrapper.offsetHeight + "px";
    } else {
      modal.style.maxHeight = 0;
    }
    modal.classList.toggle("shown");
  };

  // Positioning modal
  const adjustModalPosition = () => {
    shareModals.forEach((modal) => {
      let scrollWidth = 17;
      let parent = modal.parentNode;
      let parentRect = parent.getBoundingClientRect();
      let parentRightDistance = window.innerWidth - parentRect.left - scrollWidth;
      let rect = modal.getBoundingClientRect();
      let leftDistance = rect.left;
      let rightDistance = window.innerWidth - rect.right - scrollWidth;
      let targetRightDistance = 10;
      if (leftDistance > rightDistance) {
        if (parentRightDistance - rect.width < 0) {
          let targetMarginLeft = rect.width - parentRightDistance + targetRightDistance;
          modal.style.marginLeft = `-${targetMarginLeft}px`;
        } else if (rightDistance > rect.width) {
          modal.style.marginLeft = "unset";
        }
      } else {
        modal.style.marginLeft = "unset";
      }
    });
  };

  adjustModalPosition();

  window.addEventListener("resize", adjustModalPosition);

  const clickOutsideModal = (el, handler) => {
    const listener = (e) => {
      if (!el || el.contains(e.target) || e.target.closest(".share-socials__btn")) return;
      handler(e);
    };

    document.addEventListener("click", listener);
    document.addEventListener("touchstart", listener);
  };

  shareModals.forEach((modal) => {
    clickOutsideModal(modal, () => {
      modal.style.maxHeight = 0;
      modal.classList.remove("shown");
    });
  });

  shareBtns.forEach((btn) => {
    const modal = btn.parentElement.querySelector(".share-socials__modal");
    btn.addEventListener("click", (e) => {
      toggleModal(modal);
    });
  });

  // Сopyboard btn
  const copyToClipBoardElems = document.querySelectorAll(".copy-to-clipboard");

  copyToClipBoardElems.forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      if (navigator.clipboard) {
        const textToCopy = el.getAttribute("href");
        navigator.clipboard.writeText(textToCopy);
      }
    });
  });
});
